angular.module('autoremind.templates')
    .directive('adminTemplatesAr2Users', ['logger', 'templateAr2Service', '$uibModal',
    function (logger, templateAr2Service, $uibModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/templates/admin-templates-ar2-users.html',
            scope: {
                userId: '='
            },
            link: function ($scope, element, attrs) {
                console.log('adminTemplatesAr2Users');
                element.addClass('adminTemplatesUsers');
                $scope.templateAr2Service = templateAr2Service;
                $scope.templateAr2Service.userModel.userId = $scope.userId;
                $scope.templateAr2Service.userModel.templates = [];
                $scope.viewModel = {
                    messagesSort: { column: "createdInt", descending: true },
                };
                $scope.loadUserTemplates = function () {
                    $scope.templateAr2Service.getUserTemplates();
                };
                $scope.$watch('userId', function () {
                    $scope.loadUserTemplates();
                });
                $scope.removeUserTemplate = function (template) {
                    $scope.templateAr2Service.removeUserTemplate(template);
                };
                $scope.previewEditTemplateDialog = function (template) {
                    var templateData = {
                        fileName: template.fileName,
                        type: template.type,
                        sourceOfTemplate: angular.copy(template)
                    };
                    $scope.templateAr2Service.previewEditTemplateDialog(templateData);
                };
                $scope.selectTemplate = function (template) {
                    $scope.templateAr2Service.currentTemplate = angular.copy(template);
                };
                $scope.upload = function (template) {
                    $scope.selectTemplate(template);
                    template.file = angular.copy(template.fileName);
                    if (template.countOfTemplateFileUsages > 0) {
                        $scope.templateAr2Service.showErrorIfFileIsUsed()
                            .then(function () {
                            $scope.uploadTemplate(template, true);
                        });
                        return;
                    }
                    $scope.uploadTemplate(template);
                };
                $scope.uploadTemplate = function (template, isCustomTemplate) {
                    var modalInstance;
                    var modalScope = $scope.$new();
                    modalScope.template = angular.isDefined(template) ? template : {};
                    modalScope.isCustomTemplate = isCustomTemplate;
                    modalScope.success = function () {
                        modalInstance.close(modalScope.selected);
                    };
                    modalScope.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                    modalInstance = $uibModal.open({
                        template: '<template-ar2-upload></template-ar2-upload>',
                        size: 'lg',
                        backdrop: 'static',
                        scope: modalScope
                    });
                };
            }
        };
    }]);
//# sourceMappingURL=admin-templates-ar2-users.js.map